module.exports = __webpack_public_path__ + "img/bell.d7f98528.png";